// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__C538q","selected":"styles_selected__29nO_"};